import { Modal, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { CopyOutlined } from '@ant-design/icons';
import { Input, Typography, Button } from '@atoms';
import {
  RepostCopyButton,
  RepostCopyInputWrapper,
  RepostCopyLine,
  RepostCopyTitleWrapper
} from '../../organisms/Repost/repost.styles';

import whatsApp from "@assets/icons/whatsApp.svg"
import tg from "@assets/icons/tg.svg"
import ok from "@assets/icons/ok.svg"
import vk from "@assets/icons/vk.svg"
import mail from "@assets/icons/mail.svg"

interface IShared {
  isVisible: boolean,
  onClose: () => void,
  storyLink: string
}

const ShareModal = ({ isVisible, onClose, storyLink }: IShared) => {
  const { t } = useTranslation();

  const handleShare = (platform: string) => {
    const url = encodeURIComponent(window.location.href.replace('/my-stories/', '/stories/'));
    const text = encodeURIComponent(t("checkStory"));

    let shareUrl = "";

    switch (platform) {
      case "vk":
        shareUrl = `https://vk.com/share.php?url=${url}`;
        break;
      case "telegram":
        shareUrl = `https://t.me/share/url?url=${url}&text=${text}`;
        break;
      case "whatsapp":
        shareUrl = `https://wa.me/?text=${text}%20${url}`;
        break;
      case "odnoklassniki":
        shareUrl = `https://connect.ok.ru/offer?url=${url}&title=${text}`;
        break;
      case "mail":
        shareUrl = `mailto:?subject=${text}&body=${url}`;
        break;
      default:
        return;
    }

    window.open(shareUrl, "_blank");
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(window.location.href.replace('/my-stories/', '/stories/'));
    toast.success(t("linkСopied"), { autoClose: 2000 });
  };

  return (
    <Modal
      title={<Typography as='h3' style={{ marginBottom: "20px" }}>{t("shareStory")}</Typography>}
      open={isVisible}
      onCancel={onClose}
      closeIcon={null}
      styles={{
        header: {
          background: "rgba(249, 242, 236, 1)",
          textAlign: "center"
        },
        content: {
          background: "rgba(249, 242, 236, 1)"
        }
      }}
      width={549}
      footer={[
        <Button variant="outlined" key="cancel" onClick={onClose}>
          {t("close")}
        </Button>
      ]}
    >
      <Row gutter={16} justify="center" align="top" style={{ gap: "16px" }}>
        <Col style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
          <img src={vk} alt="vk" onClick={() => handleShare('vk')} />
          <p style={{ fontSize: "12px", color: "rgba(166, 158, 149, 1)", marginTop: "8px" }}>{t("vk")}</p>
        </Col>
        <Col style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
          <img src={tg} alt="tg" onClick={() => handleShare('telegram')} />
          <p style={{ fontSize: "12px", color: "rgba(166, 158, 149, 1)", marginTop: "8px" }}>Telegram</p>
        </Col>
        <Col style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
          <img src={whatsApp} alt="whatsApp" onClick={() => handleShare('whatsapp')} />
          <p style={{ fontSize: "12px", color: "rgba(166, 158, 149, 1)", marginTop: "8px" }}>WhatsApp</p>
        </Col>
        <Col style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
          <img src={ok} alt="ok" onClick={() => handleShare('odnoklassniki')} />
          <p style={{ fontSize: "12px", color: "rgba(166, 158, 149, 1)", marginTop: "8px" }}>Ok</p>
        </Col>
        <Col style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
          <img src={mail} alt="mail" onClick={() => handleShare('mail')} />
          <p style={{ fontSize: "12px", color: "rgba(166, 158, 149, 1)", marginTop: "8px", whiteSpace: "break-spaces", textAlign: "center" }}>{t("sharedEmail")}</p>
        </Col>
      </Row>

      <RepostCopyTitleWrapper>
        <RepostCopyLine/>
        <Typography style={{ color: "rgba(166, 158, 149, 1)" }}>{t("copyLink")}</Typography>
        <RepostCopyLine/>
      </RepostCopyTitleWrapper>
      <RepostCopyInputWrapper>
        <Input value={window.location.href.replace('/my-stories/', '/stories/')}/>
        <RepostCopyButton onClick={handleCopy}>
        <CopyOutlined />
        </RepostCopyButton>
      </RepostCopyInputWrapper>
    </Modal>
  );
};

export default ShareModal;
